import React from "react";
import "./deviceManagement.scss";
import Tabs from "components/Tabs/index";
import DeviceManagementIcons from "constants/DeviceManagement/index";
import SecretsTable from "components/SecretsTable/SecretsTable";
import { SecretTypes } from "constants/setup/countries";
import useScreenMobile from "hooks/useScreen";

const DeviceManagement = ({
  activeTab,
  setActiveTab,
  handleCreateSecretModal,
  secretsList,
  setSecretsList,
  formData,
  setFormData,
  setFormErrors,
  formErrors,
  handleSaveAddSecret,
  searchQuery = "",
  setActiveCard
}) => {
  const tabIconKeys = [
    "secret",
    // "token",
    // "certificate",
    // "keys",
    // "keyValue",
    // "password"
  ];

  const tabsTitles = SecretTypes;
  const selectedTabName = SecretTypes[activeTab];

  const TabComponents = SecretTypes.map((type, idx) => (
    <SecretsTable
      activeTab={activeTab}
      key={type}
      handleCreateSecretModal={handleCreateSecretModal}
      secretsList={secretsList}
      setSecretsList={setSecretsList}
      setFormData={setFormData}
      formData={formData}
      formErrors={formErrors}
      setFormErrors={setFormErrors}
      hasTabData={secretsList}
      selectedTab={selectedTabName}
      handleSaveAddSecret={handleSaveAddSecret}
      searchQuery={searchQuery}
      setActiveCard={setActiveCard}
    />
  ));

  return (
    <section className="container deviceManagement">
      {/* <h3 className="deviceManagementHeading">Secret Management</h3> */}
      <Tabs
        tabsTitles={tabsTitles}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabIconKeys={tabIconKeys}
        TabIcons={DeviceManagementIcons}
        marginBottom={useScreenMobile({ size: 992 }) ? "2px" : "16px"}
      />
      <div className="tabContent">{TabComponents[activeTab]}</div>
    </section>
  );
};

export default DeviceManagement;
